export default __webpack_public_path__ + "static/media/boulder_dragon.0b15e57a.png";